import pako from 'pako'
const store = require('store');

const util = {
    /**
     * 时间转字符串
     */
    time2str: (stamp) => {
        let time = new Date(new Date() - new Date(stamp)).getTime();
        let min = time / (1000 * 60);
        let hour = min / 60;
        let day = hour / 24;
        let month = day / 30;
        let year = month / 12;

        if (min < 60) {
            return Math.floor(min) + '分钟';
        }
        else if (hour < 24) {
            return Math.floor(hour) + '小时';
        }
        else if (day < 30) {
            return Math.floor(day) + '天';
        }
        else if (month < 12) {
            return Math.floor(month) + '月';
        }
        else {
            return Math.floor(year) + '年';
        }
    },

    /**
     * 格式化日期
     */
    timeFormat: (date, fmt)=> {
        var o = {
            "M+": date.getMonth() + 1, //月份 
            "d+": date.getDate(), //日 
            "h+": date.getHours(), //小时 
            "m+": date.getMinutes(), //分 
            "s+": date.getSeconds(), //秒 
            "q+": Math.floor((date.getMonth() + 3) / 3), //季度 
            "S": date.getMilliseconds() //毫秒 
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
    },

    /**
     * 转换封面 url 为实际 url
     */
    // url2real = (url) => {
    //     if(url.search(/agent/i) === -1) {
    //     }
    // },

    /**
     * 将数字带上单位, 如12345, 转换为1.2万字
     */
    wordCount2str: (wordCount) => {
        let arr = Array.from(String(wordCount));
        if(arr.length > 4) {
            arr.length -= 4;
            wordCount = arr.join('') + '万'
        }
        if(wordCount <= 0) wordCount = 0
        return wordCount + '字'
    },

    /**
     * 存储 localStorage
     */
    setStore: (name, content) => {
        if(! name) return
        return store.set(name, content)
    },

    /**
     * 获取 localStorage
     */
    getStore: (name) => {
        if(! name) return
        return store.get(name)
    },

    /**
     * 删除 localStorage
     */
    removeStore: (name) => {
        if(! name) return
        return store.remove(name)
    },

    /**
     * 通过 id 获取 当前存储 小说详情的数组
     */
    getOneBookStore: (id) => {
        let bookitemStore = store.get('bookList') || []
        let bookData = bookitemStore.filter(
            book => {
                if(book.id == id) return book
            }
        )
        return bookData[0] || []
    },

    /**
     * gzip数据解压
     */
    gzipDecode: (b64Data) => {
        // 一个是加密：window.btoa()，一个是解密：window.atob()
        let decodedData = window.atob(b64Data);

        // 字符串转数组，在循环返回一个 Unicode表所在位置的新数组
        let charData = decodedData.split('').map(x => x.charCodeAt(0));

        // Uint8Array 数组类型表示一个8位无符号整型数组，创建时内容被初始化为0。创建完后，可以以对象的方式或使用数组下标索引的方式引用数组中的元素。
        let binData = new Uint8Array(charData);

        // 调用pako 解析
        let data  = pako.inflate(binData);

        //接受 Unicode 值，然后返回字符串。
        // return String.fromCharCode.apply(null, new Uint16Array(data)); 

        // 当解析的数据较大，以上返回会报Maximum call stack size exceeded错误
        // 参考：https://stackoverflow.com/questions/6965107/converting-between-strings-and-arraybuffers/20604561#20604561， 
        let bufView = new Uint16Array(data);
        let length = bufView.length;
        let result = '';
        let addition = Math.pow(2,16)-1;

        for(let i = 0;i<length;i+=addition){

            if(i + addition > length){
                addition = length - i;
            }
            result += String.fromCharCode.apply(null, bufView.subarray(i,i+addition));
        }

        return result;
    },

    /**
     * gzip数据压缩
     */
    gzipEncode: (text) => {
        let binaryString = pako.gzip(encodeURIComponent(text), { to: 'string' });
        return window.btoa(binaryString);
    }

}

export default util